/* istanbul ignore file */
import React from 'react';
import { ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';
import SingleProjectBreadcrumbs from 'domain/projects/project/shared/SingleProjectBreadcrumbs';
import { useProjectDashboardUrl } from '../dashboardRouting';

const ProjectDashboardBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getListUrl } = useProjectDashboardUrl();
  const dashboardUrl = getListUrl();

  return (
    <SingleProjectBreadcrumbs>
      <ListBreadcrumbItem entity="Dashboard" link={dashboardUrl} />
      {children}
    </SingleProjectBreadcrumbs>
  );
};

export default ProjectDashboardBreadcrumbs;
